import { Injectable } from '@angular/core';
import { FieldBase } from './field-base';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Injectable()
export class FieldService {
  createFormControl(field: FieldBase<any>): UntypedFormControl {
    if (field.required) {
      return new UntypedFormControl(field.value, Validators.required);
    } else {
      return new UntypedFormControl(field.value);
    }
  }

  toFormGroup(formFields: FieldBase<any>[], subscriptions: Subscription[]): UntypedFormGroup {
    const group: any = {};
    formFields.forEach((field) => {
      let formControl: UntypedFormControl;
      if (field.controlType === 'checkbox') {
        formControl = new UntypedFormControl(field.value);
      } else {
        formControl = this.createFormControl(field);
      }
      group[field.id] = formControl;
      if (subscriptions) {
        subscriptions.push(formControl.valueChanges.subscribe((value) => (field.value = value)));
      }
    });
    return new UntypedFormGroup(group);
  }
}
